import { useEffect, useState } from "react";
import { X, Download, Share } from "lucide-react";

const DISMISS_KEY = "atable_install_dismissed_v1";

function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

function isIOS() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onBIP = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onBIP);
    let t;
    if (isIOS()) t = setTimeout(() => setShow(true), 1800); // iOS: pas d'event -> aide manuelle
    return () => {
      window.removeEventListener("beforeinstallprompt", onBIP);
      if (t) clearTimeout(t);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      const choice = await deferred.userChoice;
      setDeferred(null);
      setShow(false);
      if (choice.outcome === "accepted") localStorage.setItem(DISMISS_KEY, "1");
    } else {
      setIosHelp(true);
    }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-24 z-[60] mx-auto max-w-md px-4 at-fade-up" data-testid="install-prompt">
      <div className="flex items-center gap-3 rounded-2xl border border-black/5 bg-white p-3 at-shadow-lg">
        <img src="/icons/icon-192.png" alt="À Table" className="h-11 w-11 shrink-0 rounded-xl" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">Installer À Table</p>
          <p className="text-xs" style={{ color: "var(--at-text-2)" }} data-testid="install-prompt-text">
            {iosHelp
              ? "Appuyez sur le bouton Partager de votre navigateur, puis « Sur l'écran d'accueil »."
              : "Ajoutez l'app à votre écran d'accueil pour l'ouvrir en un tap."}
          </p>
        </div>
        {!iosHelp && (
          <button
            data-testid="install-accept-btn"
            onClick={install}
            className="flex shrink-0 items-center gap-1.5 rounded-xl px-3 py-2 text-sm font-semibold text-white at-press"
            style={{ background: "var(--at-brand)" }}
          >
            {isIOS() ? <Share size={16} /> : <Download size={16} />} Installer
          </button>
        )}
        <button
          data-testid="install-dismiss-btn"
          onClick={dismiss}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full at-press"
          style={{ color: "var(--at-muted)" }}
          aria-label="Fermer"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
